import { Suspense } from 'react'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router-dom'
import AuthNavigateRegistrar from '@/components/auth/AuthNavigateRegistrar'
import CatalogCodeBootstrap from '@/components/auth/CatalogCodeBootstrap'
import RouteSuspenseFallback from '@/components/RouteSuspenseFallback'
import appShellRoutes from '@/routes/appShellRoutes'
import authRoutes from '@/routes/authRoutes'
import IntegrationsCallbackPage from '@/pages/IntegrationsCallback/IntegrationsCallbackPage'
import RootRedirect from '@/routes/RootRedirect'
import PATHS from '@/routes/paths'

function RootLayout() {
  return (
    <>
      <AuthNavigateRegistrar />
      <Suspense fallback={<RouteSuspenseFallback />}>
        <CatalogCodeBootstrap>
          <Outlet />
        </CatalogCodeBootstrap>
      </Suspense>
    </>
  )
}

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />}>
      <Route path={PATHS.ROOT} element={<RootRedirect />} />
      {/* Unprotected: the OAuth provider lands here in a fresh popup that may
          not carry the session, and the page reveals nothing either way. */}
      <Route path={PATHS.INTEGRATIONS_CALLBACK} element={<IntegrationsCallbackPage />} />
      {authRoutes()}
      {appShellRoutes()}
      <Route path="*" element={<RootRedirect />} />
    </Route>,
  ),
)

export default function AppRouter() {
  return <RouterProvider router={router} />
}
